// extracted by mini-css-extract-plugin
export var header = "_g9-0";